import { render, staticRenderFns } from "./InsurerParticipantsAccounting.vue?vue&type=template&id=4f88ccee&scoped=true&"
import script from "./InsurerParticipantsAccounting.vue?vue&type=script&lang=js&"
export * from "./InsurerParticipantsAccounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88ccee",
  null
  
)

export default component.exports